import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { alertActions } from '../redux/AlertController';

export const useAnalyticsReports = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.userController.user);
    const [isLoading, setIsLoading] = useState(false);
    const [report, setReport] = useState(null);

    const fetchAnalytics = useCallback(async ({ topic, startDate, endDate, timeframe }) => {
        if (!user?.token) return null;

        try {
            setIsLoading(true);
            const params = new URLSearchParams();
            if (topic) params.append('topic', topic);
            if (startDate) params.append('startDate', startDate);
            if (endDate) params.append('endDate', endDate);
            if (timeframe) params.append('timeframe', timeframe);

            const response = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/api/admin/reports/analytics?${params.toString()}`,
                {
                    headers: {
                        Authorization: `Bearer ${user.token}`,
                    },
                }
            );

            const json = await response.json();
            if (!response.ok) {
                throw new Error(json.error || 'فشل تحميل التقارير');
            }

            setReport(json);
            return json;
        } catch (error) {
            dispatch(alertActions.showAlert({ msg: error.message, type: 'error' }));
            return null;
        } finally {
            setIsLoading(false);
        }
    }, [dispatch, user]);

    return {
        report,
        isLoading,
        fetchAnalytics,
    };
};
